import userRoles from 'app/userRoles';
import React from 'react';

const FAQPageConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: [
    userRoles.ROLE_SUPER_ADMIN,
    userRoles.ROLE_FAQ_LIST,
    userRoles.ROLE_FAQ_THEMATIC_LIST,
    userRoles.ROLE_FAQ_CATEGORY_LIST,
    userRoles.FRANCHISEE_FAQ_LIST,
    userRoles.FRANCHISEE_FAQ_THEMATIC_LIST,
    userRoles.FRANCHISEE_FAQ_CATEGORY_LIST
  ],
  routes: [
    {
      exact: true,
      path: '/faq',
      component: React.lazy(() => import('./FAQPage'))
    }
  ]
};

const FAQEditPageConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: [
    userRoles.ROLE_SUPER_ADMIN,
    userRoles.ROLE_FAQ_ADD,
    userRoles.ROLE_FAQ_EDIT,
    userRoles.FRANCHISEE_FAQ_ADD,
    userRoles.FRANCHISEE_FAQ_EDIT
  ],
  routes: [
    {
      exact: true,
      display: 'reseau',
      path: '/faq/create',
      component: React.lazy(() => import('./FAQCreatePage'))
    },
    {
      exact: true,
      display: 'reseau',
      path: '/faq/:id',
      component: React.lazy(() => import('./FAQEditPage'))
    }
  ]
};

const FAQThematicEditPageConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: [
    userRoles.ROLE_SUPER_ADMIN,
    userRoles.ROLE_FAQ_ADD,
    userRoles.ROLE_FAQ_EDIT,
    userRoles.FRANCHISEE_FAQ_ADD,
    userRoles.FRANCHISEE_FAQ_EDIT
  ],
  routes: [
    {
      exact: true,
      display: 'reseau',
      path: '/faqThematic/create',
      component: React.lazy(() => import('./FAQThematicCreatePage'))
    },
    {
      exact: true,
      display: 'reseau',
      path: '/faqThematic/:id',
      component: React.lazy(() => import('./FAQThematicEditPage'))
    },
    {
      exact: true,
      path: '/faqThematic/:id/faqCategory/create',
      component: React.lazy(() => import('./FAQCategoryCreatePage'))
    },
    {
      exact: true,
      path: '/faqCategory/:id/faq/create',
      component: React.lazy(() => import('./FAQCreatePage'))
    }
  ]
};

const FAQCategoryEditPageConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: [
    userRoles.ROLE_SUPER_ADMIN,
    userRoles.ROLE_FAQ_EDIT,
    userRoles.FRANCHISEE_FAQ_EDIT
  ],
  routes: [
    {
      exact: true,
      path: '/faqCategories/:id',
      component: React.lazy(() => import('./FAQCategoryEditPage'))
    }
  ]
};

export {
  FAQPageConfig,
  FAQEditPageConfig,
  FAQThematicEditPageConfig,
  FAQCategoryEditPageConfig
};
